import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import userActionTypes from 'redux/users/types';

const INITIAL_STATE = {
  isLoading: false,
  currentUser: null,
  error: null,
};

function userReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case userActionTypes.USER_LOGIN_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case userActionTypes.USER_LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        currentUser: payload,
      };
    case userActionTypes.USER_LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
}

const persistConfig = {
  key: 'users',
  storage,
  blacklist: ['error', 'isLoading'],
};

export default persistReducer(persistConfig, userReducer);
